import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index.js';
import less from 'less'
import Vant from 'vant';
import { Toast } from 'vant'
import VueWechatTitle from 'vue-wechat-title'




Vue.use(VueWechatTitle)
import 'vant/lib/index.css';
import '@/assets/css/react.css'
import '@/uitls/vant-ui'
Vue.use(less)
Vue.use(Vant)
Vue.use(Toast)
Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router  // router 挂载到根实例对象上
}).$mount('#app')
